var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChromeBrowser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "k3w78rfq1a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1486 0v950H0V0h1486z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a6vrmmr7nb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.856 0a16 16 0 0 1 13.857 8L.96 25.28 0 8a16 16 0 0 1 13.856-8z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g4x9gw3vrd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.144 0 6.928 12L31.68 8 16 24A16 16 0 0 1 2.144 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "csdgffe7rf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.853 0A16 16 0 0 1 0 24l6.928-12L0 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "qvzxjxwsjh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x5z60f60bi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.336 0a6.336 6.336 0 1 1 0 12.672A6.336 6.336 0 0 1 6.336 0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oha72tn6tc",
    x1: 0.003,
    y1: 10,
    x2: 27.713,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC050D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE2A25",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a10gmh1w4e",
    x1: 17.731,
    y1: 22.999,
    x2: 3.875,
    y2: -1.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009031",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AA47",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vp2biuwk0g",
    x1: -2.336,
    y1: 24.001,
    x2: 11.52,
    y2: 0.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k3w78rfq1a)",
    transform: "translate(-405 -285)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a6vrmmr7nb)",
    transform: "translate(407.14 285)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#oha72tn6tc)",
    d: "M0 0h27.713v25.28H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g4x9gw3vrd)",
    transform: "translate(405 293)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a10gmh1w4e)",
    d: "M0 0h31.68v24H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#csdgffe7rf)",
    transform: "translate(421 293)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#vp2biuwk0g)",
    d: "M0 0h15.997v24H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#qvzxjxwsjh)",
    transform: "translate(413 293)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h16v16H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x5z60f60bi)",
    transform: "translate(414.664 294.664)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0075F0",
    d: "M0 0h12.672v12.672H0V0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromeBrowser);
export default __webpack_public_path__ + "static/media/chrome-browser.87872075c6954cbb3e5ed0e8b4a15732.svg";
export { ForwardRef as ReactComponent };